<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-29 10:41:41
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-19 14:34:18
 * @Description: file content
 query参数
 regtype sale销售 agent中介
 -->
<template>
  <div class="mine_hf" v-if="userInfo">
    <!-- 用户信息区 开始 -->
    <div class="ui">
      <div class="ui_left">
        <div class="ui_headline">
          <img v-bind:src="userInfo.ui.headimg" />
        </div>
      </div>
      <div class="ui_right">
        <!-- 没有提交注册 -->
        <div class="no_reg" v-if="registerType == ''">
          <div class="ui_name">{{userInfo.ui.name}}</div>
          <div class="ui_apply_status" v-if="registerStatusMsg">{{registerStatusMsg}}</div>
        </div>
        <!-- 中介 -->
        <div class="reg" v-if="registerType == 'agent'">
          <div class="ui_name">{{agentName || userInfo.ui.name}}</div>
          <div class="ui_apply_status" v-if="registerStatusMsg">{{registerStatusMsg}}</div>
        </div>
        <!-- 注册提交了 -->
        <div class="reg" v-if="registerType == 'saler'">
          <div class="ui_name">{{ userInfo.ui.name}}</div>
          <div class="ui_apply_status" v-if="registerStatusMsg">{{registerStatusMsg}}</div>
        </div>
        <!-- 放置个显眼的合伙人注册 -->
        <div class="ui_reg_agent" @click="clickRegisterAgent" v-if="isShowRegisterBtn">全民经纪人注册</div>

        <div class="ui_reg_agent2" @click="clickCertification" v-if="isShowCertification">身份变更</div>
      </div>
    </div>
    <!-- 用户信息区 结束 -->

    <!-- 销售-置业顾问 开始 -->
    <div v-if="isShowSaleMenuItems">
      <div class="line"></div>
      <div class="menu">
        <div class="menu_item" v-for="item in saleMenuItems.toker" @click="clickMenu(item)">
          <img :src="item.icon" />
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
    <!-- 销售-置业顾问 结束 -->

    <!-- 中介 开始 -->
    <div v-if="isShowAgentMenuItems">
      <div class="line"></div>
      <div class="menu">
        <div class="menu_item" v-for="item in agentMenuItems.toker" @click="clickMenu(item)">
          <img :src="item.icon" />
          <div>{{item.name}}</div>
        </div>
      </div>
    </div>
    <!-- 中介 结束 -->

    <!-- 通用功能按钮区域 -->
    <div class="line"></div>
    <div class="menu-layer">
      <div
        class="menu-item border-bottom"
        v-for="(item,index) in noSaleNoAgentMenuItems"
        :key="index"
        @click="clickMenu(item)"
      >
        <img :src="item.icon" />
        <div class="title">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";

import { MessageBox, Toast } from "mint-ui";
import Cookies from "js-cookie";
export default {
  components: {},
  props: {},
  data() {
    return {
      headimg: "",
      // 普通用户菜单
      noSaleNoAgentMenuItems: [
        // lj30
        {
          icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdll.png",
          name: "我的浏览",
          type: "link",
          // repository: "shqc-web",
          // value: "rs-fmarket-visit.html"
          repository: "yq-rs-wx",
          value: "rs/list-visit"
        },
        {
          icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wddd.png",
          name: "我的订单",
          type: "link",
          // repository: "yq-act-web",
          repository: "yq-rs-make",
          value: ""
        },
        // lj31
        {
          icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdxx.png",
          name: "我的消息",
          type: "link",
          // repository: "shqc-web",
          // value: "rs-fmarket-notice.html"
          repository: "yq-rs-wx",
          value: "rs/list-notice"
        },
        {
          icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_yjfk.png",
          name: "意见反馈",
          type: "methods",
          repository: "",
          value: "clickYjfk"
        }
      ],
      // 是否展示直接注册区域和显眼的注册按钮
      isShowRegisterBtn: false,
      // 是否显示修改个人信息
      isShowCertification: false,
      // 注册类型
      registerType: "",
      // 注册状态
      registerStatusMsg: "",

      // 销售菜单
      saleMenuItems: {
        toker: [
          // lj32
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_xxxs2.png",
            name: "销售线索",
            type: "link",
            // repository: "shqc-web",
            // value: "rs-fmarket-track.html"
            repository: "yq-rs-wx",
            value: "rs/list-track"
          },
          // lj33
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_cbnr2.png",
            name: "传播内容",
            type: "link",
            // repository: "shqc-web",
            // value: "rs-fmarket-share.html"
            repository: "yq-rs-wx",
            value: "rs/list-content"
          },
          // lj34
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_fssz2.png",
            name: "粉丝受众",
            type: "link",
            // repository: "shqc-web",
            // value: "rs-fmarket-fans.html"
            repository: "yq-rs-wx",
            value: "rs/list-fans"
          },
          // lj35
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdph2.png",
            name: "我的排行",
            type: "link",
            // repository: "shqc-web",
            // value: "rs-desk-rank.html"
            repository: "yq-rs-wx",
            value: "rs/list-rank"
          }
        ]
      },
      // 是否展示销售员菜单
      isShowSaleMenuItems: false,

      //中介菜单
      agentMenuItems: {
        toker: []
      },
      // 是否展示中介菜单
      isShowAgentMenuItems: false,
      // 用户整体信息
      userIntegralInfo: null,

      agentMobile: "",
      agentName: ""
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    clickMenu(item) {
      console.log(JSON.parse(JSON.stringify(item)));
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
      }
      let url = "";
      if (
        item.type == "link" &&
        item.repository == "shqc-web" &&
        item.value &&
        initObj
      ) {
        url = `${location.protocol}//${location.host}/marketies/rc/${item.value}`;
        if (item.value == "rs-desk-rank.html") {
          url += "?from=person";
        }
        util.openShqcWebLink(url);
      } else if (
        item.type == "link" &&
        item.repository == "hf-web" &&
        item.value
      ) {
        // this.goYxPage(item.value);
        if(this.isInMiniProgram) {        
          let url = `${location.protocol}//${location.host}/h5/qmyx/${item.value}`;
          util.openYqRsMakeLink(url);
        } else {
          this.$router.push(`/qmyx/${item.value}`);
        }
      } else if (
        item.type == "link" &&
        item.repository == "yq-rs-wx" &&
        item.value &&
        initObj
      ) {
        url = `${location.protocol}//${location.host}/marketies/rsrc/${item.value}?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        if (this.global.isLoc) {
          url = `http://localhost:2001/marketies/rsrc/${item.value}?entry=zxslzx&t9id=${initObj.id}&t9psn=${initObj.psn}`;
        }
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        if (item.value == "rs/court-management") {
          url += `&pid=${this.pageInfo.Pid}`;
        }
        if (item.value == "rs/list-rank") {
          if(this.registerStatusMsg == '置业顾问') {

          }
          url += `&role=${this.registerStatusMsg == '置业顾问' ? 1 : 2}`;
        }
        util.openUrl(url);
      } else if (
        item.type == "link" &&
        item.repository == "yq-rs-make" &&
        initObj
      ) {
        if(this.isInMiniProgram) {        
          let url = `${location.protocol}//${location.host}/h5/t9_order`;
          util.openYqRsMakeLink(url);
        } else {
          this.$router.push("t9_order");
        }        
      } else if (
        item.type == "link" &&
        item.repository == "yq-act-web" &&
        initObj
      ) {
        //我的订单
        let appid = this.global.APPID;
        let openid = Cookies.get("openid");
        let backurl = `${location.protocol}//${location.host}/h5/t9_my?id=${initObj.id}&psn=${initObj.psn}`;
        // 如果有传播者也一并把传播者传到打开的页面
        if (this.receiveSpreadInfo.refereeopenid) {
          backurl += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
        }
        if (this.receiveSpreadInfo.rscuid) {
          backurl += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
        }
        // let url = `${
        //   location.protocol
        // }//${appid}.web.ruthyx.com/act/online/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-list?o=${openid}&backurl=${encodeURIComponent(
        //   backurl
        // )}`;
        let url = ''
        if(util.checkIsHuafaTest()) {
          url = `${location.protocol}//dy-web.huafacrm.com/act/test/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-list?o=${openid}&backurl=${encodeURIComponent(backurl)}`;        
        } else {
          url = `${location.protocol}//dy-web.huafacrm.com/act/online/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-list?o=${openid}&backurl=${encodeURIComponent(backurl)}`;           
        }
        util.openUrl(url);
      } else if (item.type == "methods") {
        this[item.value]();
      } else if (item.type === "inner-page") {
        // this.$router.push(`/qmyx/${item.value}`);
        if(this.isInMiniProgram) {        
          let url = `${location.protocol}//${location.host}/h5/qmyx/${item.value}`;
          util.openYqRsMakeLink(url);
        } else {
          this.$router.push(`/qmyx/${item.value}`);
        }
      } else {
        MessageBox.alert("敬请期待!");
      }
    },
    clickRegisterAgent() {
      // this.$router.push("/qmyx/agent-auth");
      if(this.isInMiniProgram) {        
        let url = `${location.protocol}//${location.host}/h5/qmyx/agent-auth`;
        util.openYqRsMakeLink(url);
      } else {
        this.$router.push("/qmyx/agent-auth");
      }
      // this.goYxPage("agentauth");
    },
    clickCertification() {
      // this.$router.push("/qmyx/agent2");
      if(this.isInMiniProgram) {        
        let url = `${location.protocol}//${location.host}/h5/qmyx/agent2`;
        util.openYqRsMakeLink(url);
      } else {
        this.$router.push("/qmyx/agent2");
      }
      // this.goYxPage("identitychange");
    },
    // 销售名片
    clickInfo() {
      let url = `${this.isInMiniProgram ? "https" : "http"}://${
        location.host
      }/h5/usercard2.html?openid=${this.$openid}`;
      url += `&entry=zxslzx&t9id=${this.receiveSpreadInfo.id}&t9psn=${this.receiveSpreadInfo.psn}`;
      // 如果有传播者也一并把传播者传到打开的页面
      if (this.receiveSpreadInfo.refereeopenid) {
        url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
      }
      if (this.receiveSpreadInfo.rscuid) {
        url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
      }
      util.openYqRsH5Link(url, this.userInfo);
    },
    //意见反馈
    // lj20
    clickYjfk() {
      this.$router.push("t9_suggest");
    },
    // 销售修改信息
    clickModify() {
      let url = `${this.isInMiniProgram ? "https" : "http"}://${
        location.host
      }/marketies/rc/rs-desk-modifyInfo.html`;
      url += `?entry=zxslzx&t9id=${this.receiveSpreadInfo.id}&t9psn=${this.receiveSpreadInfo.psn}`;
      // 如果有传播者也一并把传播者传到打开的页面
      if (this.receiveSpreadInfo.refereeopenid) {
        url += `&refereeopenid=${this.receiveSpreadInfo.refereeopenid}`;
      }
      if (this.receiveSpreadInfo.rscuid) {
        url += `&rscuid=${this.receiveSpreadInfo.rscuid}`;
      }
      util.openShqcWebLink(url);
    },

    //跳转营销页面
    goYxPage(act) {
      let mobile = util.getUserMobile(this.userInfo) || this.agentTel;
      let backurl = `${location.protocol}//${location.host}/h5/t9_my`;
      let url = util.getHfYxUrl(act, mobile, "", backurl);
      util.openUrl(url);
    },

    /**
     * 初始化
     */
    init() {
      return new Promise((resolve, reject) => {
        util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
          this.headimg = util.getUserHeadimg(this.userInfo);
          // 是否注册过
          comreq.getUserIntegralInfo().then(userInfo => {
            this.userIntegralInfo = userInfo;
            console.log("用户完整信息", JSON.parse(JSON.stringify(userInfo)));
            // 测试数据开始
            if (this.global.isLoc) {
              // // 1、销售
              // userInfo.isSale = true;
              // userInfo.userInfo.role = [{ roleid: 2011 }];
              // 2、案场管理人
              // userInfo.isSale = true;
              // userInfo.userInfo.role = [{ roleid: 2015 }];
              // // 3、中介
              // userInfo.isAgent = true;
              // userInfo.isSale = false;
              // // 4、非销售非中介
              // userInfo.isSale = false;
              // userInfo.isAgent = false;
              // // 附加状态
              // userInfo.saleStatusMsg = "审核中";
            }
            // 测试数据结束
            /**
             * 角色判断
             */
            // 销售
            if (userInfo.isSale == true) {
              this.isShowSaleMenuItems = true;
              this.registerType = "saler";
              let is2015 = false;
              let is2013 = false;
              if (userInfo.userInfo.role && userInfo.userInfo.role.length > 0) {
                userInfo.userInfo.role.forEach(item => {
                  if (item.roleid == 2015) {
                    is2015 = true;
                  }
                  if (item.roleid == 2013) {
                    is2013 = true;
                  }
                });
              }
              if (is2015) {
                this.registerStatusMsg = "案场管理人";
              } else if (is2013) {
                this.registerStatusMsg = "销售经理";
              } else {
                this.registerStatusMsg = "置业顾问";
              }
              // lj36
              this.noSaleNoAgentMenuItems.push({
                icon:
                  "http://assets.rurushishi.com/yq-rs-make/huafa/icon_xsrk.png",
                name: "销售入口",
                type: "link",
                repository: "shqc-web",
                value: "rs-desk-person.html"
              });
            } else {
              //判断是否华发营销客户
              let agentTel = util.getUserMobile(this.userInfo);
              if (!agentTel) {
                agentTel = "X";
              }
              comreq.checkIsYxUser(
                // `${this.global.HF_YXCONFIG.api}/${agentTel}/${Cookies.get(
                //   "openid"
                // )}`
                `${this.global.HF_YXCONFIG.apiurl}agentAccount/loginByCityOpenId/${Cookies.get("openid")}`
              ).then(res => {
                if (res.code == "200") {
                  if (res.data && res.data.id) {
                    this.isShowAgentMenuItems = true;
                    this.isShowCertification = true;
                    this.isShowRegisterBtn = false;
                    this.registerType = "agent";
                    this.registerStatusMsg = util.getHfAgentUserType(
                      res.data.status
                    );
                    this.agentTel = res.data.agentTel ? res.data.agentTel : "";
                    this.agentName = res.data.agentName
                      ? res.data.agentName
                      : "";
                      
                    this.noSaleNoAgentMenuItems.pop()
                    this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.concat([{
                      icon: "http://assets.rurushishi.com/yq-rs-make/huafa/rencaifuwu.png",
                      name: "发展经纪人",
                      type: "inner-page",
                      repository: "hf-web",
                      value: "invite-client"
                    }])
                    if(this.registerStatusMsg == '拓客') {
                    // if(this.registerStatusMsg == '全民经纪人') {
                      this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.concat([{
                        icon: "http://assets.rurushishi.com/yq-rs-make/huafa/rencaifuwu5.png",
                        name: "发展经纪人推荐客户查询",
                        type: "inner-page",
                        repository: "hf-web",
                        value: "invite-client-recommend-customers"
                      }])                      
                    }
                    this.noSaleNoAgentMenuItems = this.noSaleNoAgentMenuItems.concat([{
                        icon: "http://assets.rurushishi.com/yq-rs-make/huafa/jifen.png",
                        name: "我的积分",
                        type: "inner-page",
                        repository: "hf-web",
                        value: "my-score"
                      },{
                        icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_yjfk.png",
                        name: "意见反馈",
                        type: "methods",
                        repository: "",
                        value: "clickYjfk"
                      }])
                  } else {
                    this.isShowRegisterBtn = true;
                  }
                } else {
                  this.isShowRegisterBtn = true;
                }
              });
            }
            resolve();
          });
        });
      });
    },
  },
  created() {
    this.init();
  },
  mounted() {
    let that = this;
    // if(util.checkIsHuafaTest()) {
      that.agentMenuItems.toker =  [
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_bbkh2.png",
            name: "报备客户",
            type: "inner-page",
            repository: "hf-web",
            value: "client-backup"
          },
          {
            icon:
              "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdkh2.png",
            name: "我的客户",
            type: "inner-page",
            repository: "hf-web",
            value: "my-customer"
          },
          {
            icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_sfrz.png",
            name: "实名认证",
            type: "inner-page",
            repository: "hf-web",
            value: "certification"
          },
          {
            icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdyj2.png",
            name: "我的佣金",
            type: "inner-page",
            repository: "hf-web",
            value: "cash-back"
          }
      ]
    // } else {
    //   that.agentMenuItems.toker = [
    //     {
    //       icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_bbkh2.png",
    //       name: "报备客户",
    //       type: "link",
    //       repository: "hf-web",
    //       value: "recommend"
    //     },
    //     {
    //       icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdkh2.png",
    //       name: "我的客户",
    //       type: "link",
    //       repository: "hf-web",
    //       value: "cus"
    //     },
    //     {
    //       icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_sfrz.png",
    //       name: "实名认证",
    //       type: "link",
    //       repository: "hf-web",
    //       value: "certification"
    //     }
    //     // {
    //     //   icon: "http://assets.rurushishi.com/yq-rs-make/huafa/icon_wdyj2.png",
    //     //   name: "我的佣金",
    //     //   type: "link",
    //     //   repository: "hf-web",
    //     //   value: "commission"
    //     // }
    //   ];
    // }
  }
};
</script>
<style lang="css" scoped>
.mine_hf {
  padding-bottom: 20px;
}
.ui {
  width: 100%;
  height: 2.33rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/huafa/header2.png")
    no-repeat center center;
  background-size: 100% 2.33rem;
  display: flex;
}

.ui_left {
  width: 2rem;
  height: 2.33rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ui_headline img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 1.2rem;
  border: 2px solid #ffffff;
}

.ui_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
}
.ui_right .no_reg {
  width: 3rem;
  position: relative;
}
.ui_right .no_reg .ui_name {
  font-size: 0.3rem;
  line-height: 0.5rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui_right .no_reg .ui_apply_status {
  font-size: 0.3rem;
  line-height: 0.5rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui_right .reg {
  width: 5rem;
  position: relative;
}
.ui_right .reg .ui_name {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui_right .reg .ui_apply_status {
  font-size: 0.3rem;
  line-height: 0.4rem;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ui_right .reg .ui_op {
  padding-top: 2px;
}
.ui_right .reg .ui_op > img {
  width: 25px;
  height: auto;
}
.ui_right .reg .ui_op > img:nth-child(2) {
  padding-left: 20px;
}

.ui_right .ui_reg_agent {
  position: absolute;
  width: 2.12rem;
  height: 0.62rem;
  background-color: transparent;
  border: 1px solid #ffffff;
  top: 0.85rem;
  right: 0.5rem;
  font-size: 0.25rem;
  line-height: 0.62rem;
  border-radius: 4px;
  color: #ffffff;
  font-size: 0.24rem;
  text-align: center;
}

.ui_right .ui_reg_agent2 {
  position: absolute;
  width: 1.8rem;
  height: 0.62rem;
  background-color: transparent;
  border: 1px solid #ffffff;
  top: 0.85rem;
  right: 0.5rem;
  font-size: 0.25rem;
  line-height: 0.62rem;
  border-radius: 4px;
  color: #ffffff;
  font-size: 0.24rem;
  text-align: center;
}

.line {
  width: 100%;
  height: 4px;
  background-color: #f4f4f4;
}

.menu {
  display: flex;
  flex-wrap: wrap;
}
.menu_item {
  display: flex;
  width: 25%;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0.3rem 0;
}
.menu_item > img {
  width: 0.62rem;
  height: 0.62rem;
  display: block;
}
.menu_item > div {
  width: 100%;
  color: #333333;
  margin-top: 10px;
  font-size: 13px;
}

.area_title {
  width: 100%;
  height: 40px;
  padding: 5px 0;
  /*color: #2ca9df;*/
  background: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  border-bottom: 1px solid #ededed;
}

.area_title > span {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  line-height: 30px;
  background: url(http://assets.rurushishi.com/rsicon/icon0.png) no-repeat;
  background-size: 100% 100%;
  margin: 0px 8px;
}
.cut_line {
  background: #f4f4f4;
  height: 5px;
  width: 100%;
  margin-top: 20px;
}
.btn1 {
  border: 1px solid #ef8532;
  color: #ef8532;
  width: 80%;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.5rem;
  font-size: 0.35rem;
  text-align: center;
  margin: 0.3rem auto;
}

.menu-layer .menu-item {
  line-height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.2rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/sysintro/arrow.png")
    no-repeat right 10px center;
  background-size: 0.2rem 0.2rem;
}
.menu-layer .menu-item > img {
  display: block;
  width: 0.42rem;
  height: 0.42rem;
  margin-top: -2px;
}
.menu-layer .menu-item .title {
  padding-left: 0.1rem;
  font-size: 0.28rem;
  color: #333333;
  flex: 1;
}
</style>